import request from '@/utils/request'
export function fetchList(data) {
  return request({
    url: '/LogLockerActivity/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/LogLockerActivity/Get',
    method: 'post',
    data: { id: id },
  })
}

export function createItem(data) {
  console.log('createItem', data)
  return request({
    url: '/LogLockerActivity/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)
  return request({
    url: '/LogLockerActivity/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/LogLockerActivity/Delete',
    method: 'delete',
    data,
  })
}
